import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icon-back.svg'
import _imports_1 from '@/assets/images/icon-excel.svg'
import _imports_2 from '@/assets/images/icon-arrow-green.svg'
import _imports_3 from '@/assets/images/icon-arrow-red.svg'


const _withScopeId = n => (_pushScopeId("data-v-39479396"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid grid-cols-1 place-items-center w-full" }
const _hoisted_2 = { class: "flex flex-col gap-4 w-full lg:w-4/6" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-[12px]" }, "Volver", -1))
const _hoisted_5 = { class: "flex flex-col gap-4 w-full" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row w-full items-center" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-[16px] font-bold" }, "Mis movimientos")
], -1))
const _hoisted_7 = { class: "flex flex-col sm:flex-row sm:items-center gap-4 sm:justify-between" }
const _hoisted_8 = { class: "flex flex-col sm:flex-row gap-4 sm:items-center" }
const _hoisted_9 = { class: "relative flex flex-row justify-between items-center gap-2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "whitespace-nowrap" }, "Fecha de inicio", -1))
const _hoisted_11 = { class: "w-36 sm:w-full" }
const _hoisted_12 = { class: "relative flex flex-row justify-between items-center gap-2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "whitespace-nowrap" }, "Fecha de término", -1))
const _hoisted_14 = { class: "w-36 sm:w-full" }
const _hoisted_15 = { class: "flex flex-row justify-end sm:justify-between items-center gap-4" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1" }, "Excel", -1))
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = { class: "w-full h-full overflow-auto" }
const _hoisted_20 = { class: "table-auto w-full" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "border-thead" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "font-bold text-start px-2 py-2 whitespace-nowrap" }, "Fecha"),
    /*#__PURE__*/_createElementVNode("th", { class: "font-bold px-2 py-2 whitespace-nowrap text-center" }, " Acciones B "),
    /*#__PURE__*/_createElementVNode("th", { class: "font-bold px-2 py-2 whitespace-nowrap text-center" }, " Nº Total Acc. B "),
    /*#__PURE__*/_createElementVNode("th", { class: "font-bold px-2 py-2 whitespace-nowrap text-center" }, " Acciones ")
  ])
], -1))
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "text-start px-2 py-2" }
const _hoisted_24 = { class: "py-2 px-4" }
const _hoisted_25 = {
  key: 0,
  class: "flex justify-center items-center"
}
const _hoisted_26 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "h-[17px]",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_28 = {
  key: 1,
  class: "flex items-center justify-center"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "h-[17px]",
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = {
  key: 1,
  class: "flex justify-center items-center gap-2"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "0", -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = { class: "py-2 px-4" }
const _hoisted_35 = { class: "flex justify-center" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { key: 1 }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "4",
    class: "p-4 text-center"
  }, "No hay elementos en la lista")
], -1))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = {
  key: 0,
  class: "text-center text-[16px] mt-2"
}
const _hoisted_41 = { class: "flex w-full items-center justify-center pt-8 gap-1" }
const _hoisted_42 = { class: "flex items-center" }
const _hoisted_43 = ["onClick"]

import { computed, onMounted, watch, ref, Ref } from "vue";
import { storeToRefs } from "pinia";
import { ShareholderMovement } from "@/services/movements/types";
import { shareMovementStore } from "@/stores/movements";
import { accountStore } from "@/stores/account";

import moment from "moment";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShareholderSharesTable',
  setup(__props) {

const movementsStore = shareMovementStore();
const accountStr = accountStore();

const { filter } = storeToRefs(movementsStore);

const activeAccount = computed(() => accountStr.activeAccount);
const currentPage = computed(() => movementsStore.currentPage);
const totalPages = computed(() => movementsStore.totalPages);
const perPage = computed(() => movementsStore.perPage);
const showFirstPages = computed(() => currentPage.value <= perPage.value);
const showLastPages = computed(
  () => currentPage.value > totalPages.value - perPage.value
);

const movements = computed(() => {
  return [...movementsStore.movements];
});

const isBuyer = (movement: ShareholderMovement) => {
  return movement.buyerUserId == activeAccount.value;
}

const getAmountB = (movement: ShareholderMovement) => {
  if (isBuyer(movement)) return +movement.groupBAmount;
  return -movement.groupBAmount;
}

const downloadExcel = () => {
  movementsStore.movementService.downloadExcel(
    activeAccount.value,
    filter.value
  );
}

const visiblePages = computed(() => {
  if (showFirstPages.value) {
    return Array.from(
      { length: Math.min(perPage.value, totalPages.value) },
      (_, index) => index + 1
    );
  } else if (showLastPages.value) {
    return Array.from(
      { length: Math.min(perPage.value, totalPages.value) },
      (_, index) => totalPages.value - 10 + index
    );
  } else {
    return Array.from(
      { length: perPage.value },
      (_, index) => currentPage.value - 5 + index
    );
  }
});
const goToPage = (page: number) => {
  if (page >= 1 && page <= totalPages.value) {
    movementsStore.currentPage = page;
    movementsStore.query(currentPage.value);
  }
};
const previousPage = () => {
  if (currentPage.value > 1) {
    movementsStore.currentPage--;
    movementsStore.query(currentPage.value);
  }
};
const nextPage = () => {
  if (currentPage.value < totalPages.value) {
    movementsStore.currentPage++;
    movementsStore.query(currentPage.value);
  }
};
const lastPage = () => {
  if (currentPage.value < totalPages.value) {
    movementsStore.currentPage = totalPages.value;
    movementsStore.query(currentPage.value);
  }
};
const firstPage = () => {
  movementsStore.currentPage = 1;
  movementsStore.query(currentPage.value);
};

const downloadContract = async (movementId: number) => {
  movementsStore.movementService.downloadContract(movementId);
};

watch(filter.value, () => {
  movementsStore.query(currentPage.value);
});

onMounted(() => {
  movementsStore.query(currentPage.value);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_mdicon = _resolveComponent("mdicon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "total-balance view-movement flex items-center justify-start gap-4",
        "active-class": "font-bold text-green-700",
        to: { name: 'MyStocks' }
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _hoisted_4
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_Datepicker, {
                  modelValue: _unref(filter).start_date,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filter).start_date) = $event)),
                  "teleport-center": "",
                  "input-class-name": "newcalssinput",
                  "enable-time-picker": false,
                  format: "MM/yyyy",
                  cancelText: 'Cancelar',
                  selectText: 'Seleccionar'
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_Datepicker, {
                  modelValue: _unref(filter).end_date,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(filter).end_date) = $event)),
                  "teleport-center": "",
                  "input-class-name": "newcalssinput",
                  "enable-time-picker": false,
                  "min-date": _unref(filter).start_date,
                  format: "MM/yyyy",
                  cancelText: 'Cancelar',
                  selectText: 'Seleccionar'
                }, null, 8, ["modelValue", "min-date"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
              class: "bg-white text-[#5F5F5F] button-excel w-full sm:w-[124px] h-[33px] flex gap-2 text-sm items-center justify-center",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (downloadExcel()))
            }, _hoisted_18)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("table", _hoisted_20, [
          _hoisted_21,
          (_unref(activeAccount) != 0 && _unref(movements) && _unref(movements).length > 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_22, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(movements), (movement) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: movement.id,
                    class: "hover:bg-gray-100 cursor-pointer"
                  }, [
                    _createElementVNode("td", _hoisted_23, _toDisplayString(_unref(moment)(movement.createdAt).format("DD/MM/YYYY")), 1),
                    _createElementVNode("td", _hoisted_24, [
                      (getAmountB(movement) != 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            (movement.buyerUserId == _unref(activeAccount))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                  _hoisted_27,
                                  _createTextVNode("+ ")
                                ]))
                              : _createCommentVNode("", true),
                            (movement.buyerUserId != _unref(activeAccount))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_30))
                              : _createCommentVNode("", true),
                            _createElementVNode("p", null, _toDisplayString(getAmountB(movement)), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_33))
                    ]),
                    _createElementVNode("td", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, _toDisplayString(movement.buyerUserId == _unref(activeAccount)
                      ? movement.buyerGroupBFinalAmount
                      : movement.sellerGroupBFinalAmount), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("button", {
                        class: "hover:scale-110 transition-all",
                        onClick: ($event: any) => (downloadContract(movement.id))
                      }, [
                        _createVNode(_component_mdicon, { name: "file-download" })
                      ], 8, _hoisted_36)
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_37, _hoisted_39))
        ]),
        (_unref(activeAccount) == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_40, " Por favor seleccione una cuenta "))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_41, [
        _createVNode(_component_mdicon, {
          class: "border-l-1 cursor-pointer bg-[#008B4E] text-white hover:bg-primary-green/50 focus:bg-primary-green/hover:bg-primary-green/50 rounded-full",
          name: "chevron-double-left",
          disabled: _unref(currentPage) === 1,
          onClick: firstPage
        }, null, 8, ["disabled"]),
        _createVNode(_component_mdicon, {
          class: "border-l-1 cursor-pointer bg-[#008B4E] text-white hover:bg-primary-green/50 focus:bg-primary-green/hover:bg-primary-green/50 rounded-full",
          name: "chevron-left",
          disabled: _unref(currentPage) === 1,
          onClick: previousPage
        }, null, 8, ["disabled"]),
        _createElementVNode("div", _hoisted_42, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visiblePages), (page) => {
            return (_openBlock(), _createElementBlock("span", {
              key: page,
              class: _normalizeClass([
              'cursor-pointer',
              'px-3',
              {
                'bg-[#008B4E] text-white font-bold': _unref(currentPage) === page,
                'bg-[#F0F0F0] text-[#969393] ': _unref(currentPage) !== page,
              },
            ]),
              onClick: ($event: any) => (goToPage(page))
            }, _toDisplayString(page), 11, _hoisted_43))
          }), 128))
        ]),
        _createVNode(_component_mdicon, {
          class: "cursor-pointer bg-[#008B4E] text-white hover:bg-primary-green/50 focus:bg-primary-green/hover:bg-primary-green/50 rounded-full",
          name: "chevron-right",
          disabled: _unref(currentPage) === _unref(totalPages),
          onClick: nextPage
        }, null, 8, ["disabled"]),
        _createVNode(_component_mdicon, {
          class: "cursor-pointer bg-[#008B4E] text-white hover:bg-primary-green/50 focus:bg-primary-green/hover:bg-primary-green/50 rounded-full",
          name: "chevron-double-right",
          disabled: _unref(currentPage) === _unref(totalPages),
          onClick: lastPage
        }, null, 8, ["disabled"])
      ])
    ])
  ]))
}
}

})